import React from 'react';
import { motion } from 'framer-motion';
import { Dna, BookOpen } from 'lucide-react';
export function WhyItWorksSection() {
  return <section className="py-12 px-4 bg-cream" data-id="element-229">
      <div className="max-w-4xl mx-auto" data-id="element-230">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-231">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-charcoal mb-4 uppercase tracking-wide" data-id="element-232">
            Por qué este proceso funciona
          </h2>
          <p className="text-lg md:text-xl text-charcoal-light" data-id="element-233">
            No es una opinión. Es{' '}
            <span className="text-gold-dark font-bold" data-id="element-234">ciencia</span> y{' '}
            <span className="text-gold-dark font-bold" data-id="element-235">fe</span> trabajando
            juntas.
          </p>
        </motion.div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-236">
          {/* Science Card */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-white p-8 border border-gold/20 shadow-sm flex flex-col items-center text-center rounded-sm" data-id="element-237">
            <div className="bg-cream-light p-4 rounded-full mb-6" data-id="element-238">
              <Dna className="text-charcoal" size={32} data-id="element-239" />
            </div>
            <p className="text-charcoal-light leading-relaxed" data-id="element-240">
              La Universidad de Harvard confirmó en 2023 que los traumas no
              resueltos se codifican en el ADN y se transmiten a las siguientes
              generaciones.
            </p>
          </motion.div>

          {/* Faith Card */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="bg-charcoal p-8 border border-gold/30 shadow-md flex flex-col items-center text-center rounded-sm" data-id="element-241">
            <div className="bg-charcoal-light/20 p-4 rounded-full mb-6 border border-gold/20" data-id="element-242">
              <BookOpen className="text-gold" size={32} data-id="element-243" />
            </div>
            <p className="text-cream-dark leading-relaxed" data-id="element-244">
              La Biblia lo describe en Éxodo 20:5 como la iniquidad de los
              padres sobre los hijos.
            </p>
          </motion.div>
        </div>

        {/* Closing Statement */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="text-center" data-id="element-245">
          <p className="text-xl md:text-2xl font-serif text-charcoal max-w-3xl mx-auto leading-relaxed" data-id="element-246">
            Cuando atacas{' '}
            <span className="text-gold-dark font-bold" data-id="element-247">el origen</span> — no los
            síntomas — el ciclo se rompe para siempre.
          </p>
        </motion.div>
      </div>
    </section>;
}